import React from 'react'


function Team() {
    return (
        <div className='container mt-5 mb-5'>
            <div className='row'>
                <div className='col px-5 mt-3 text-center'>
                    <img src='/media/Nikhil.jpg' style={{ borderRadius: "100%", width: "70%" }} /><br /><br />
                    <h3 className='fs-5' >Nikhil Kamath</h3>
                    <h5 className='fs-6'>Co-founder & CFO</h5>
                    <h7>bio</h7>
                </div>
                <div className='col mt-3 text-center'>
                    <img src='/media/Kailash.jpg' style={{ borderRadius: "100%", width: "70%" }} /><br /><br />
                    <h3 className='fs-5' >Dr. Kailash Nadh</h3>
                    <h5 className='fs-6'>CTO</h5>
                     <h7>bio</h7>
                </div>
                <div className='col px-5 mt-3 text-center'>
                    <img src='/media/Venu.jpg' style={{ borderRadius: "100%", width: "70%" }} /><br /><br />
                    <h3 className='fs-5' >Venu Madhav</h3>
                    <h5 className='fs-6'>COO</h5>
                     <h7>bio</h7>
                </div>

            </div>
            <div className='row'>
                <div className='col px-5 mt-3 text-center'>
                    <img src='/media/Seema.jpg' style={{ borderRadius: "100%", width: "70%" }} /><br /><br />
                    <h3 className='fs-5' >Seema Patil</h3>
                    <h5 className='fs-6'>Director</h5>
                     <h7>bio</h7>
                </div>
                <div className='col mt-3 text-center'>
                    <img src='/media/karthik.jpg' style={{ borderRadius: "100%", width: "70%" }} /><br /><br />
                    <h3 className='fs-5' >Karthik Rangappa</h3>
                    <h5 className='fs-6'>Chief of Education</h5>
                     <h7>bio</h7>
                </div>
                <div className='col px-5 mt-3 text-center'>
                    <img src='/media/Austin.jpg' style={{ borderRadius: "100%", width: "70%" }} /><br /><br />
                    <h3 className='fs-5' >Austin Prakesh</h3>
                    <h5 className='fs-6'>Director Strategy</h5>
                     <h7>bio</h7>
                </div>

            </div>
        </div>
    );
}

export default Team;